import CreateBanner from "./CreateBanner";


export default function MainBanner() {
    return (
        <div>
            <CreateBanner Type={"MAIN"} />
        </div>
    )
}